import { render, staticRenderFns } from "./PricingGuidesCard.vue?vue&type=template&id=7fe9dd74&"
import script from "./PricingGuidesCard.vue?vue&type=script&lang=js&"
export * from "./PricingGuidesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fe9dd74')) {
      api.createRecord('7fe9dd74', component.options)
    } else {
      api.reload('7fe9dd74', component.options)
    }
    module.hot.accept("./PricingGuidesCard.vue?vue&type=template&id=7fe9dd74&", function () {
      api.rerender('7fe9dd74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/dashboard/cards/PricingGuidesCard.vue"
export default component.exports